"use strict";
/**
 * @file Created on 13.07.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var NChangedGroupOfSitesDTO_1 = require("./NChangedGroupOfSitesDTO");

var NChangedProdThresholdDTO_1 = require("./NChangedProdThresholdDTO");

var NChangedProductDTO_1 = require("./NChangedProductDTO");

var NChangedWinDate_1 = require("./NChangedWinDate");

var NChangedWinThreshold_1 = require("./NChangedWinThreshold");

var NotificationDoc_1 = require("../NotificationDoc");

var NChangedWinPriceValidity_1 = require("./NChangedWinPriceValidity");
/**
 * @author MHl
 */


var NChangedWindowDTO =
/*#__PURE__*/
function (_NotificationDoc_1$No) {
  _inherits(NChangedWindowDTO, _NotificationDoc_1$No);

  /**
   * @param windowDateChange
   * @param productsChange
   * @param productsGosChange
   * @param productThresholdChange
   * @param windowThresholdChange
   */
  function NChangedWindowDTO(windowDateChange, productsChange, productsGosChange, productThresholdChange, windowThresholdChange, windowPriceValidityChange) {
    var _this;

    _classCallCheck(this, NChangedWindowDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NChangedWindowDTO).call(this));
    _this.windowDateChange = windowDateChange;
    _this.productsChange = productsChange;
    _this.productsGosChange = productsGosChange;
    _this.productThresholdChange = productThresholdChange;
    _this.windowThresholdChange = windowThresholdChange;
    _this.windowPriceValidityChange = windowPriceValidityChange;
    return _this;
  }
  /**
   * Converter from data-dictionary representation
   */


  _createClass(NChangedWindowDTO, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new NChangedWindowDTO(mat.windowDateChange, mat.productsChange, mat.productsGosChange, mat.productThresholdChange, mat.windowThresholdChange, mat.windowPriceValidityChange);
    }
  }]);

  return NChangedWindowDTO;
}(NotificationDoc_1.NotificationDoc);

exports.NChangedWindowDTO = NChangedWindowDTO;
/**
 * IOC Container qualifier
 */

NChangedWindowDTO.QUALIFIER = {
  documentType: NChangedWindowDTO.name
};

NChangedWindowDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(NChangedWindowDTO.name);
  return {
    windowDateChange: builder.opt(builder.obj('windowDateChange', NChangedWinDate_1.NChangedWinDate.schema, function (mat) {
      return NChangedWinDate_1.NChangedWinDate.fromDataDict(mat);
    })),
    productsChange: builder.opt(builder.obj('productsChange', NChangedProductDTO_1.NChangedProductDTO.schema, function (mat) {
      return NChangedProductDTO_1.NChangedProductDTO.fromDataDict(mat);
    })),
    productsGosChange: builder.opt(builder.obj('productsGosChange', NChangedGroupOfSitesDTO_1.NChangedGroupOfSitesDTO.schema, function (mat) {
      return NChangedGroupOfSitesDTO_1.NChangedGroupOfSitesDTO.fromDataDict(mat);
    })),
    productThresholdChange: builder.opt(builder.obj('productThresholdChange', NChangedProdThresholdDTO_1.NChangedProdThresholdDTO.schema, function (mat) {
      return NChangedProdThresholdDTO_1.NChangedProdThresholdDTO.fromDataDict(mat);
    })),
    windowThresholdChange: builder.opt(builder.obj('windowThresholdChange', NChangedWinThreshold_1.NChangedWinThreshold.schema, function (mat) {
      return NChangedWinThreshold_1.NChangedWinThreshold.fromDataDict(mat);
    })),
    windowPriceValidityChange: builder.opt(builder.obj('windowPriceValidityChange', NChangedWinPriceValidity_1.NChangedWinPriceValidity.schema, function (mat) {
      return NChangedWinPriceValidity_1.NChangedWinPriceValidity.fromDataDict(mat);
    }))
  };
}();